<script setup lang="ts">
import {QrFormType} from "@/scripts/types/qr";
import {defineProps} from "vue";

export interface Props {
    modelValue: string;
}

const props = defineProps<Props>();

const emit = defineEmits<{
    (e: 'update:modelValue', value: string): void
}>();

const changeType = (newType: QrFormType) => {
    emit('update:modelValue', newType);
}

</script>

<template>
    <h3>Форма</h3>
    <div class="flex">
        <div
            class="cursor-pointer p-2 bg-purple-50 rounded mr-4 inline-block"
            :class="{'border border-purple-900' : props.modelValue === QrFormType.SQUARE}"
            @click="changeType(QrFormType.SQUARE)"
        >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="3" width="18" height="18" rx="4" fill="white"/>
                <rect x="4" y="4" width="16" height="16" rx="3" stroke="#111111" stroke-width="2"/>
            </svg>
        </div>

        <div
            class="cursor-pointer p-2 bg-purple-50 rounded mr-4 inline-block"
            :class="{'border border-purple-900' : props.modelValue === QrFormType.CIRCLE}"
            @click="changeType(QrFormType.CIRCLE)"
        >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="white"/>
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
                      fill="#111111"/>
            </svg>
        </div>
    </div>

</template>